import { Form, Radio, Space } from 'antd';
import { BaseEntityFieldValidator, VatValidator } from '@ppvrbh/merchant-core';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RBHAutoComplete, RBHBox, RBHButton, RBHRadio, RBHText, RBHTextInput } from '../../../../../shared/components';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import styleText from '../../../../../shared/components/rbh-text/styles';
import styleTextInput from '../../../../../shared/components/rbh-textinput/styles';
import { VatAddress } from '../../../../../shared/models/vat-address';
import { VAT_REQUEST_ID_LIST } from '../../redux/vat-constant';
import { vatSagas } from '../../redux/vat-saga';
import { VatService } from '../../redux/vat-service';
import styles from './styles';
import './style.css';
import { VAT_STATE_KEY, vatStateSelector } from '../../redux/vat-reducer';

export const FormAddEdit: React.FC<Props> = (p) => {
  let vat;
  if (p.editData) {
    vat = new VatAddress(p.editData);
  }

  const [form] = Form.useForm();
  const options = require('../../../../../shared/resources/zipcode/province.min.json');
  const [zipcode, setZipcode] = React.useState(vat ? vat.vatAddressPostalCode : '');
  const [radioValue, setRadioValue] = React.useState(
    vat ? vat.vatAddressBranchNo ? vat.vatAddressBranchNo === '00000' ? 'mainBranch' : 'branchNo' : undefined : undefined);
  const subdistrict = React.useState(vat ? vat.vatAddressSubdistrict : '');
  const [district] = React.useState('');
  const [province] = React.useState('');
  const [formInvalid, setFormInvalid] = useState(vat ? vat.vatAddressBranchNo ? false : true : true);
  const [vatId] = React.useState(vat ? vat.vatAddressId : undefined);
  const dispatch = useDispatch();
  const history = useHistory();
  const prefillData = useSelector(vatStateSelector(VAT_STATE_KEY.PREFILL));

  useEffect(() => {
    if (p.editData) {
      form.validateFields(['vatAddressDetail']);
    }
    return () => {
      if (history.action === 'POP' && p.editData) {
        history.push('/main/vataddress');
      }
    };
  }, [history]);

  const onChangeZipcodeSubdistrict = (e: any) => {
    const newData = e.split(',');
    setZipcode(newData[3]);
  };

  const onSelect = (e: any) => {
    const newData = e.split(',');
    form.setFieldsValue({
      vatAddressPostalCode: newData[3],
      vatAddressSubdistrict: newData[0],
      vatAddressDistrict: newData[1],
      vatAddressProvince: newData[2]
    });
  };

  const onBlur = () => {
    const zipcodeValue = form.getFieldValue('vatAddressPostalCode');
    if (zipcode !== zipcodeValue) {
      form.setFieldsValue({
        vatAddressPostalCode: '',
        vatAddressSubdistrict: '',
        vatAddressDistrict: '',
        vatAddressProvince: '',
      });
    }
    form.validateFields(['vatAddressPostalCode', 'vatAddressSubdistrict', 'vatAddressDistrict']);
  };

  const toVat = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main/vataddress');
  };

  const onFinish = (values: any) => {
    let branchNo = '';
    if (values.branchNoOption === 'mainBranch') {
      branchNo = '00000';
    } else {
      branchNo = values.vatAddressBranchNo;
    }
    const data = {
      vatAddressId: Number(vatId),
      vatAddressTaxId: values.vatAddressTaxId,
      vatAddressName: values.vatAddressName,
      vatAddressDetail: values.vatAddressDetail,
      vatAddressPostalCode: values.vatAddressPostalCode,
      vatAddressSubdistrict: values.vatAddressSubdistrict,
      vatAddressDistrict: values.vatAddressDistrict,
      vatAddressProvince: values.vatAddressProvince,
      vatAddressBranchNo: branchNo
    };

    if (p.editData) {
      dispatch(httpCreators.request({
        id: VAT_REQUEST_ID_LIST.PATCH_VAT,
        sagaHandler: vatSagas.patchVatHandler as any,
        callbackParams: p.onSuccessCallback,
        service: VatService.patchVat,
        serviceParams: data,
      }));
    } else {
      delete data.vatAddressId;
      dispatch(httpCreators.request({
        id: VAT_REQUEST_ID_LIST.POST_VAT,
        sagaHandler: vatSagas.postVatHandler as any,
        callbackParams: toVat,
        service: VatService.postVat,
        serviceParams: data
      }));
    }
  };

  const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
  };

  const button = {
    wrapperCol: { offset: 10, span: 16 },
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();

    for (const key in values) {
      if (values[key] === undefined || values[key] === '') {
        invalid = true;
        break;
      }
    }
    if (!invalid) {
      const errors = form.getFieldsError();
      for (const field of errors) {
        if (field.errors.length > 0) {
          invalid = true;
          break;
        }
      }
    }
    setFormInvalid(invalid);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const onChangeRadio = (e: any) => {
    setRadioValue(e.target.value);
    if (e.target.value === 'mainBranch') {
      form.resetFields(['vatAddressBranchNo']);
    }
  };

  return (
    <RBHBox style={styles.defaultContent}>
      <Form size='large' form={form} style={styleText.formText} {...layout} onFinish={onFinish} onFieldsChange={checkFormInvalid}>
        <Form.Item validateTrigger={['onChange', 'onBlur']} colon={false} label={<FormattedMessage id={'main.vat_vatid'} />} name='vatAddressTaxId'
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> },
          { pattern: VatValidator.vatAddressTaxId.regexPattern, message: <FormattedMessage id={'main.vat_validate'} /> }]}
          // @ts-ignore
          initialValue={vat ? vat.vatAddressTaxId : prefillData ? prefillData.vatAddressTaxId : undefined}>

          <RBHTextInput disabled type='number' style={styleTextInput.inputDefault} id='vatAddressTaxId' placeholder='main.vat_inputvatid'
            maxLength={VatValidator.vatAddressTaxId.maxLength} onBlur={() => trimFieldValue('vatAddressTaxId')} />
        </Form.Item>

        <Form.Item validateTrigger={['onChange', 'onBlur']} colon={false} label={<FormattedMessage id={'main.vat_vatname'} />} name='vatAddressName'
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> },
          { pattern: VatValidator.vatAddressName.regexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> },
          { whitespace: true, message: <FormattedMessage id={'main.form.text.valid'} /> }]}
          // @ts-ignore
          initialValue={vat ? vat.vatAddressName : prefillData ? prefillData.vatAddressName : undefined}>

          <RBHTextInput disabled style={styleTextInput.inputDefault} id='vatAddressName' placeholder='main.vat_inputvatname'
            maxLength={VatValidator.vatAddressName.maxLength} onBlur={() => trimFieldValue('vatAddressName')} />
        </Form.Item>

        <Form.Item validateTrigger={['onChange', 'onBlur']} colon={false} label={<FormattedMessage id={'main.vat_form_vataddress'} />}
          name='vatAddressDetail' initialValue={vat ? vat.vatAddressDetail : undefined}
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> },
          { pattern: VatValidator.vatAddressDetailWithComma.regexPattern, message: <FormattedMessage id={'main.vat_addressdetail_inline_error'} /> },
          { whitespace: true, message: <FormattedMessage id={'main.form.text.valid'} /> },
          { max: VatValidator.vatAddressDetail.maxLength, message: <FormattedMessage id={'main.error.vat.vatAddressDetail.maxlength'} /> }
          ]}>

          <RBHTextInput style={styleTextInput.inputDefault} id='vatAddressDetail' placeholder='main.vat_inputvataddress'
            maxLength={VatValidator.vatAddressDetail.maxLength} onBlur={() => trimFieldValue('vatAddressDetail')} />
        </Form.Item>

        <Form.Item colon={false} label={<FormattedMessage id={'main.vat_vatpostalcode'} />}
          name='vatAddressPostalCode'
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> },
          { pattern: VatValidator.vatAddressPostalCode.regexPattern, message: <FormattedMessage id={'main.form.digit.only'} /> }]}
          initialValue={vat ? vat.vatAddressPostalCode : ''}>

          <RBHAutoComplete id='vatAddressPostalCode' dropdownMatchSelectWidth={400} style={styleTextInput.inputWidth180} options={options}
            onChange={onChangeZipcodeSubdistrict} value={zipcode} placeholder='main.addzipcode'
            onSelect={onSelect} onBlur={onBlur} filterOption={true} />
        </Form.Item>

        <Form.Item colon={false} validateTrigger={['onChange', 'onBlur']} label={<FormattedMessage id={'main.vat_vatsubdistrict'} />}
          name='vatAddressSubdistrict'
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> },
          { whitespace: true, message: <FormattedMessage id={'main.form.required'} /> },
          { pattern: BaseEntityFieldValidator.genericTextInputRegexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> }]}
          initialValue={vat ? vat.vatAddressSubdistrict : ''}>

          <RBHTextInput data-testid={'vatAddressSubdistrict'} style={styleTextInput.inputWidth180} id='vatAddressSubdistrict'
            placeholder='main.vat_vatsubdistrict.desc' maxLength={40} onBlur={() => trimFieldValue('vatAddressSubdistrict')} value={subdistrict} />
        </Form.Item>

        <Form.Item colon={false} validateTrigger={['onChange', 'onBlur']} label={<FormattedMessage id={'main.vat_vatdistrict'} />}
          name='vatAddressDistrict'
          rules={[{ required: true, message: <FormattedMessage id={'main.form.required'} /> },
          { whitespace: true, message: <FormattedMessage id={'main.form.required'} /> },
          { pattern: BaseEntityFieldValidator.genericTextInputRegexPattern, message: <FormattedMessage id={'main.form.text.valid'} /> }]}
          initialValue={vat ? vat.vatAddressDistrict : ''}>

          <RBHTextInput data-testid={'vatAddressDistrict'} style={styleTextInput.inputWidth180} id='vatAddressDistrict'
            placeholder='main.vat_vatdistrict.desc' maxLength={40} onBlur={() => trimFieldValue('vatAddressDistrict')} value={district} />
        </Form.Item>

        <Form.Item colon={false} label={<FormattedMessage id={'main.vat_vatprovince'} />} name='vatAddressProvince'
          rules={[{ required: true }]} initialValue={vat ? vat.vatAddressProvince : ''}>

          <RBHAutoComplete id='vatAddressProvince' style={styleTextInput.inputWidth180} disabled={true} value={province}
            placeholder='main.addprovince' />
        </Form.Item>

        <Form.Item colon={false} name={'branchNoOption'} label={<FormattedMessage id={'main.vat_vatbranchno'} />}
          required={true} initialValue={radioValue} >
          <Radio.Group onChange={onChangeRadio}>
            <RBHRadio data-testid={'mainBranch'} id={'mainBranch'} value={'mainBranch'} style={styles.mainBranchRegular14fakeBlack}
              textOption={'main.vat_vatbranchno_mainbranch'} />

            <RBHRadio data-testid={'branchNo'} id={'branchNo'} value={'branchNo'} style={styles.branchNoRegular14fakeBlack}
              textOption={'main.vat_vatbranchno_radio'} />
            {radioValue === 'branchNo' ?
              <RBHBox style={styles.branchNoBox}>
                <Form.Item className={'vatAddressBranchNo'} name='vatAddressBranchNo' validateTrigger={['onChange', 'onBlur']} required={true}
                  rules={[
                    { required: true, message: <FormattedMessage id={'main.form.required'} /> },
                    { pattern: VatValidator.vatBranchNoFiveDigitOnly.regexPattern, message: <FormattedMessage id={'main.form.vatbranchno.valid'} /> },
                    { pattern: VatValidator.vatBranchNoFiveZero.regexPattern, message: <FormattedMessage id={'main.vat_vatbranchno_mainbranchonly_inline_error'} /> }]}
                  initialValue={vat ? vat.vatAddressBranchNo ? vat.vatAddressBranchNo === '00000' ? undefined : vat.vatAddressBranchNo : undefined : undefined}>
                  <RBHTextInput
                    style={styles.inputWidth150}
                    data-testid={'vatAddressBranchNo'}
                    id='vatAddressBranchNo'
                    name='vatAddressBranchNo'
                    placeholder='main.vat_inputvatbranchnumber'
                    maxLength={VatValidator.vatBranchNoFiveDigitOnly.maxLength}
                    autoComplete='off'
                    onBlur={() => trimFieldValue('vatAddressBranchNo')} />
                </Form.Item>
              </RBHBox> : null
            }
          </Radio.Group>
        </Form.Item>

        <Form.Item colon={false} label=' '>
          <RBHBox style={styles.remarkBox}>
            <RBHText data-testid={'vat_vatbranchno_remark'} id={'vat_vatbranchno_remark'} style={styles.regular14fakeBlack}
              text={'main.vat_vatbranchno.remark'} />
            <RBHText data-testid={'vat_vatbranchno_remarkdesc'} id={'vat_vatbranchno_remarkdesc'} style={styles.light14fakeBlack}
              text={'main.vat_vatbranchno.remarkdesc'} />
          </RBHBox>
        </Form.Item>

        <Form.Item {...button}>
          <Space size={'middle'}>
            <RBHButton id='vat_button_cancel' style={styleButton.buttonFromCancelGradient} type='primary' htmlType='button'
              onClick={p.onCancel} text='main.button_cancel' />
            <RBHButton
              disabled={formInvalid}
              type='primary'
              htmlType='submit'
              id={!vat ? 'vat_button_confirm' : 'vat_button_save'}
              style={!vat ? styleButton.buttonFromConfirmGradient : styleButton.buttonModalConfirmGradient}
              text={!vat ? 'main.vat_vatadd' : 'main.branchform.save'}
            />
          </Space>
        </Form.Item>
      </Form>
    </RBHBox>
  );
};
type Props = {
  onCancel?: any
  editData?: any
  onSuccessCallback?: any
};

